/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as components from "../components/index.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type UpdateDocumentFileRequest = {
  /**
   * The id of the document.
   */
  documentId: string;
  /**
   * An optional partition to scope the request to. If omitted, accounts created after 1/9/2025 will have the request scoped to the default partition, while older accounts will have the request scoped to all partitions. Older accounts may opt in to strict partition scoping by contacting support@ragie.ai. Older accounts using the partitions feature are strongly recommended to scope the request to a partition.
   */
  partition?: string | null | undefined;
  updateDocumentFileParams: components.UpdateDocumentFileParams;
};

/** @internal */
export const UpdateDocumentFileRequest$inboundSchema: z.ZodType<
  UpdateDocumentFileRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  document_id: z.string(),
  partition: z.nullable(z.string()).optional(),
  UpdateDocumentFileParams: components.UpdateDocumentFileParams$inboundSchema,
}).transform((v) => {
  return remap$(v, {
    "document_id": "documentId",
    "UpdateDocumentFileParams": "updateDocumentFileParams",
  });
});
/** @internal */
export type UpdateDocumentFileRequest$Outbound = {
  document_id: string;
  partition?: string | null | undefined;
  UpdateDocumentFileParams: components.UpdateDocumentFileParams$Outbound;
};

/** @internal */
export const UpdateDocumentFileRequest$outboundSchema: z.ZodType<
  UpdateDocumentFileRequest$Outbound,
  z.ZodTypeDef,
  UpdateDocumentFileRequest
> = z.object({
  documentId: z.string(),
  partition: z.nullable(z.string()).optional(),
  updateDocumentFileParams: components.UpdateDocumentFileParams$outboundSchema,
}).transform((v) => {
  return remap$(v, {
    documentId: "document_id",
    updateDocumentFileParams: "UpdateDocumentFileParams",
  });
});

export function updateDocumentFileRequestToJSON(
  updateDocumentFileRequest: UpdateDocumentFileRequest,
): string {
  return JSON.stringify(
    UpdateDocumentFileRequest$outboundSchema.parse(updateDocumentFileRequest),
  );
}
export function updateDocumentFileRequestFromJSON(
  jsonString: string,
): SafeParseResult<UpdateDocumentFileRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => UpdateDocumentFileRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'UpdateDocumentFileRequest' from JSON`,
  );
}
